<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="about-the-author">
<h1 style="font-family:Calisto MT; font-size:18pt; letter-spacing:1px; padding-top:75px; padding-bottom:15px;">About the Author</h1>
<p>Sandy Schleiffers is one of the pioneer women jockeys of yesteryear. She is the fourth woman jockey in US history to win a thoroughbred race at a pari-mutuel track. She is also the first woman jockey to be licensed and to win a race in both Arizona and Colorado history. In addition, she is the first woman admitted to the men’s Jockey Guild. Sandy rode thoroughbred races for 7 years from 1969 to 1976. At the end of 1976, Sandy retired from racing and returned to school. She finished her bachelor’s degree, a master’s degree, and finally a PhD in 1985. She is the only jockey male or female to earn a PhD Sandy is currently retired after a successful career as a lecturer at Colorado State University where she taught for 25 years.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch001.vue?9759269c